import { useSelector } from "react-redux";

export const useIsDarkTheme = () => {
    const theme = useSelector((state) => state.project.theme);
    return theme === "light";
};
